import { TableHeaderPosition, type ITableSettings } from "../types";

export const getHeaderRowIndex = (
  settings: Pick<
    ITableSettings,
    "tableRows" | "tableHasHeader" | "tableHeaderPosition"
  >,
): number => {
  const { tableRows, tableHasHeader, tableHeaderPosition } = settings;
  if (!tableHasHeader) return -1;
  if (tableHeaderPosition === TableHeaderPosition.Top) return 0;
  if (tableHeaderPosition === TableHeaderPosition.Bottom) return tableRows - 1;
  return -1;
};
